module.exports = __webpack_public_path__ + "static/media/home-fixie-tote.8c996588.jpg";